export default {
  namespaced: true,
  getters: {
    getLink: (state, getters, rootState, rootGetters) => (type, id) => {
      const body = document.body;
      body.style.height = '';
      body.style.overflowY = '';

      if (type === 'page') {
        return {
          url: rootGetters['pages/getPageURLById'](id),
          text: rootGetters['pages/getPageMenuNameById'](id),
        };
      }
      if (type === 'villa' || type === 'property') {
        const prop = rootGetters['properties/getProperyById'](id);
        if (prop) {
          return {
            url: prop.url,
            text: prop.name,
          };
        }
      }
      else if (type === 'collection' || type === 'list') {
        const all = rootGetters['lists/getAllLists'];
        if (all && all.length > 0) {
          const list = all.find((l) => l.id === Number(id));
          if (list !== undefined) {
            return {
              url: list.url,
              text: list.name,
            };
          }
        }
      }
      else if (type === 'experience') {
        const all = rootGetters['experiences/getAllExperiences'];
        if (all && all.length > 0) {
          const experience = all.find((l) => l.id === Number(id));
          if (experience) {
            return {
              url: experience.cmsRelativeUrl,
              text: experience.name,
            };
          }
        }
      }
      else if (type === 'experiencegroup') {
        const all = rootGetters['experiences/getAllExperienceGroups'];
        if (all && all.length > 0) {
          const experienceGroup = all.find((l) => l.id === Number(id));
          if (experienceGroup) {
            return {
              url: experienceGroup.cmsRelativeUrl,
              text: experienceGroup.title,
            };
          }
        }
      }
      else if (type === 'press') {
        const all = rootGetters['presspages/getAllPressPages'];
        if (all && all.length > 0) {
          const presspage = all.find((l) => l.id === Number(id));
          if (presspage) {
            return {
              url: presspage.cmsRelativeURL,
              text: presspage.name,
            };
          }
        }
      }
      else if (type === 'blog') {
        const all = rootGetters['blogs/getAllBlogArticlePages'];
        if (all && all.length > 0) {
          const blogpage = all.find((l) => l.id === Number(id));
          if (blogpage) {
            return {
              url: blogpage.cmsRelativeURL,
              text: blogpage.name,
            };
          }
        }
      }
      else if (type === 'blogtag') {
        const all = rootGetters['blogs/getAllBlogTags'];
        if (all && all.length > 0) {
          const blogtag = all.find((l) => l.id === Number(id));
          if (blogtag) {
            return {
              url: blogtag.blogTagCMSRelativeURL,
              text: blogtag.pageTitle,
            };
          }
        }
      }
      else if (type === 'blogcategory') {
        const all = rootGetters['blogs/getAllBlogCategories'];
        if (all && all.length > 0) {
          const blogtag = all.find((l) => l.id === Number(id));
          if (blogtag) {
            return {
              url: blogtag.blogTagCMSRelativeURL,
              text: blogtag.pageTitle,
            };
          }
        }
      }
    },

    replaceLinks: (state, getters) => (content) => {
      // �page�, �villa�,  �collection�, �experience�, �press�

      const regex = /(?<href>href)?=?["|']?{{(?<type>page|villa|property|collection|list|press|experience):(?<id>\d+)+(?<anchor>#+\w+)?}}["|']?/mig;

      const val = content.replace(regex, (str, ...args) => {
        const {
          href, type, id, anchor,
        } = args.pop();

        let strAnchor = '';
        if (anchor && anchor != '') {
          strAnchor = anchor;
        }

        const appLink = getters.getLink(type, id);

        if (appLink && appLink.url && appLink.text) {
          if (!href) {
            return `<a href='${appLink.url}${strAnchor}' class='router-link'>${appLink.text}</a>`;
          }
          return `href='${appLink.url}${strAnchor}'`;
        }
        if (!href) {
          return "<a href='/page-not-found' class='router-link'>page not found</a>";
        }
        return "href='/page-not-found'";
      });

      return val;
    },
  },
};
